import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';

import Map from './map';

lessRequire('modules/profile/components/timezones-map/main.less');

const propTypes = {
	showModalTimezone: PropTypes.bool,
	initialValues: PropTypes.object,
	toggleModalTimezone: PropTypes.func,
	chooseTimezoneFromMap: PropTypes.func,
	timezones: PropTypes.array,
	intl: PropTypes.func
};

const Main = props => {
	return <Map
		timezones={props.timezones}
		isOpen={props.showModalTimezone}
		onClose={() => props.toggleModalTimezone()}
		title={props.intl('Выберите таймзону')}
		activeZone={props.initialValues.timezone}
		onChoose={props.chooseTimezoneFromMap}/>;
};

Main.propTypes = propTypes;
export default Main;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/timezones-map/main.js